import { render, staticRenderFns } from "./boardProgress.vue?vue&type=template&id=3010f5aa&scoped=true"
import script from "./boardProgress.vue?vue&type=script&lang=js"
export * from "./boardProgress.vue?vue&type=script&lang=js"
import style0 from "./boardProgress.vue?vue&type=style&index=0&id=3010f5aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3010f5aa",
  null
  
)

export default component.exports